export var productTileBrandLinkPropsAdapter = function(data) {
    var trackingParams = {
        //Product token
        token: data.token,
        isPromoted: data.isPromoted,
        impressionId: data.impressionId,
        promotedBy: data.promotedBy,
        badgeList: data.badgeList,
        bestImage: data.bestImage,
        images: data.images
    };
    var _data_brandToken;
    return {
        trackingParams: trackingParams,
        brandToken: (_data_brandToken = data.brandToken) !== null && _data_brandToken !== void 0 ? _data_brandToken : "",
        productSearchString: data.productSearchString
    };
};
